export default __webpack_public_path__ + "static/media/bg2.409a2fc6.jpg";